/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import ImgUpload from '@/components/ImgUpload';
import FileUpload from '@/components/FileUpload';
import ScanCell from '@/components/ScanCell';
import PositionCell from '@/components/PositionCell';
import PopupCheckList from '@/components/CustomFormList/PopupCheckList';
import SmyXAddress from '@/components/CustomFormList/SmyXAddress';
import SmyCheckBox from '@/components/CustomFormList/SmyCheckBox';
import utils from '@/utils/utils';
import SelectPicker from '@/components/Base/SelectPicker';
import { calcFormula } from '@/utils/calculator';
import WriteExecute from '@/pages/project/detail/OrderReturnReceipt/WriteExecute';
import DatetimeRange from '@/components/CustomFormList/DatetimeRange.vue';
import axios from 'axios';
import { postUploadSaveStr } from '@/api';
import { actions, valueNameActions } from './OrderFromNode';
export default {
  name: 'CustomFormNode',
  props: {
    node: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    labelWidth: {
      type: Number,
      default: 120
    },
    getValueName: {
      type: Boolean,
      default: true
    },
    onlyCamera: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    fieldList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    DatetimeRange: DatetimeRange,
    Rater: Rater,
    WriteExecute: WriteExecute,
    SelectPicker: SelectPicker,
    Cell: Cell,
    PopupCheckList: PopupCheckList,
    XInput: XInput,
    XTextarea: XTextarea,
    Group: Group,
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ImgUpload: ImgUpload,
    FileUpload: FileUpload,
    ScanCell: ScanCell,
    PositionCell: PositionCell,
    SmyCheckBox: SmyCheckBox,
    SmyXAddress: SmyXAddress
  },
  computed: {
    fieldKey: function fieldKey() {
      var _this$node;
      return (_this$node = this.node) === null || _this$node === void 0 ? void 0 : _this$node.type;
    }
  },
  watch: {
    node: {
      handler: function handler(val) {
        var item = utils.deepCopy(val);
        var v = item;
        if ([3, 8].indexOf(v.type) !== -1) {
          v.dropList = v.dropList ? v.dropList.map(function (item) {
            return {
              value: item.id + '',
              name: item.value
            };
          }) : [];
        }
        if (v.type === 21) {
          this.loadTxtImg(item.tfvvalue).then(function (res) {
            item.tfvvalue = res;
          });
        }
        if ([18].indexOf(v.type) !== -1) {
          this.$set(v, '_isShow', false);
          this.$set(v, '_name', 'false');
          this.$set(v, 'arrvalue', v.ovalue ? v.ovalue.split(',').map(Number) : []);
        }
        if (!v.ovalue) {
          // 空数据格式化
          if (v.type === 3) {
            v.ovalue = '';
          } else if ([7, 16].indexOf(v.type) !== -1) {
            v.ovalue = 0;
          } else {
            v.ovalue = [];
          }
        } else {
          // 数据回显
          if ([3, 7, 16].indexOf(v.type) === -1) {
            // 多选数据过滤
            if (v.type === 8) {
              var value = v.ovalue.split(',');
              v.ovalue = value.filter(function (item) {
                return v.dropList.map(function (v) {
                  return v.value;
                }).includes(item);
              });
            } else {
              v.ovalue = v.ovalue.split(',');
            }
          } else {
            if ([7, 16].indexOf(v.type) !== -1) {
              v.ovalue = Number(v.ovalue);
            }
          }
        }
        if (!v.tfvvalue) {
          // 空数据格式化
          if ([10, 15].indexOf(v.type) !== -1) {
            v.tfvvalue = '';
            v.ovalue = [];
          } else {
            v.tfvvalue = '';
          }
        } else {
          // 数据回显
          if ([10, 15].indexOf(v.type) !== -1) {
            v.ovalue = v.tfvvalue.split(',');
          } else if (v.type === 4) {
            v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD');
          } else if (v.type === 5) {
            // v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('HH:mm')
          } else if (v.type === 6) {
            v.tfvvalue = new Date(utils.date.formatDate(v.tfvvalue)).Format('YYYY-MM-DD HH:mm');
          } else if (v.type === 11) {
            var pos = v.tfvvalue.split(',');
            if (pos[3] && pos[4]) {
              v.ovalue = [pos[3], pos[4]];
            } else {
              v.ovalue = [];
            }
          }
        }
        this.item = item;
      },
      deep: true,
      immediate: true
    },
    item: {
      handler: function handler(v) {
        var _this = this;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var val, obj;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  val = utils.deepCopy(v);
                  obj = {
                    id: '',
                    type: '',
                    value: ''
                  };
                  if (val.nodeId) {
                    obj.nodeId = val.nodeId;
                  }
                  if (val.tfvid) {
                    obj.tfvid = val.tfvid;
                  }
                  obj.id = val.id;
                  obj.type = val.type;
                  obj.value = _toConsumableArray(actions).find(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 1),
                      key = _ref2[0];
                    return key.test("".concat(val.type)) || key.test('default');
                  })[1](val);
                  if (_this.getValueName) {
                    obj.name = _toConsumableArray(valueNameActions).find(function (_ref3) {
                      var _ref4 = _slicedToArray(_ref3, 1),
                        key = _ref4[0];
                      return key.test("".concat(val.type)) || key.test('default');
                    })[1](val);
                  }
                  if (!(obj.type === 21)) {
                    _context.next = 12;
                    break;
                  }
                  _context.next = 11;
                  return _this.saveTxtImg(obj.value);
                case 11:
                  obj.value = _context.sent;
                case 12:
                  _this.$emit('on-customField', obj, _this.index);
                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      item: {},
      writeShow: false
    };
  },
  methods: {
    resetFormFields: function resetFormFields() {
      var _this2 = this;
      var actions = new Map([[/^(3|8|18)$/, function (val) {
        return val.ovalue = [];
      }], [/^(7|16)$/, function (val) {
        return val.ovalue = 0;
      }], [/^[456]$/, function (val) {
        return val.tfvvalue = '';
      }], [/^(9|10|11|15|26)$/, function (val) {
        val.tfvvalue = '';
        val.ovalue = [];
      }], [/^default$/, function (val) {
        return val.tfvvalue = '';
      }]]);
      _toConsumableArray(actions).find(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          key = _ref6[0];
        return key.test("".concat(_this2.item.type)) || key.test('default');
      })[1](this.item);
    },
    formValidate: function formValidate() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        _this3.formValidateFuc().then(function (res) {
          resolve(true);
        }).catch(function (e) {
          _this3.$vux.toast.text("\u8BF7\u586B\u5199".concat(e.name || e.tfname || ''));
          resolve(false);
        });
      });
    },
    formValidateFuc: function formValidateFuc() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var val = _this4.item;
        if (val.type === 2) {
          if (val.tfvvalue !== '' && !/^[0-9]+.?[0-9]*$/.test(val.tfvvalue)) {
            reject(val);
          }
        }
        if (val.type === 11) {
          resolve(true);
        } // c端不支持定位组件
        // fix 暂存后定位值等于逗号跳过了判断
        // if (11 === val.type && val.is_required === 1) {
        //   if (val.tfvvalue === ',,') {
        //     reject(val)
        //   }
        // }
        if ([23, 24, 25].includes(val.type) && val.is_required && val.is_required === 1) {
          if (val.tfvvalue === '' || val.tfvvalue === ',') {
            reject(val);
          }
        }
        if (val.is_required && val.is_required === 1) {
          if ([3, 7, 8, 9, 10, 15, 18, 26].indexOf(val.type) !== -1) {
            if (val.ovalue.length === 0) {
              reject(val);
            }
          } else {
            if (!val.tfvvalue) {
              reject(val);
            }
          }
        }
        resolve(true);
      });
    },
    numberValidate: function numberValidate(value) {
      if (!/^[0-9]+.?[0-9]*$/.test(value)) {
        return {
          valid: false,
          msg: i18n.tc("367")
        };
      }
      return {
        valid: true
      };
    },
    xAddressOnChange: function xAddressOnChange(item, val, val2) {
      item.tfvvalue = val2.join(',');
    },
    saveTxtImg: function saveTxtImg() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var base64, _yield$postUploadSave, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                base64 = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
                if (!(!base64 || !base64.includes('data:image'))) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", base64);
              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return postUploadSaveStr({
                  content: base64
                });
              case 6:
                _yield$postUploadSave = _context2.sent;
                data = _yield$postUploadSave.data;
                return _context2.abrupt("return", data);
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                return _context2.abrupt("return", '');
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11]]);
      }))();
    },
    loadTxtImg: function loadTxtImg(url) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (url) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return", '');
              case 2:
                if (!url.includes('data:image')) {
                  _context3.next = 4;
                  break;
                }
                return _context3.abrupt("return", url);
              case 4:
                _context3.next = 6;
                return axios({
                  method: 'get',
                  url: url
                });
              case 6:
                res = _context3.sent;
                return _context3.abrupt("return", res.data);
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getCamera: function getCamera(form) {
      var _form$fieldAttributeL, _form$fieldAttributeL2;
      return Boolean(Number(form === null || form === void 0 ? void 0 : (_form$fieldAttributeL = form.fieldAttributeList) === null || _form$fieldAttributeL === void 0 ? void 0 : (_form$fieldAttributeL2 = _form$fieldAttributeL.find(function (v) {
        return v.type === 1002;
      })) === null || _form$fieldAttributeL2 === void 0 ? void 0 : _form$fieldAttributeL2.value));
    },
    getWaterMask: function getWaterMask(form) {
      var _form$fieldAttributeL3, _form$fieldAttributeL4;
      return Boolean(Number(form === null || form === void 0 ? void 0 : (_form$fieldAttributeL3 = form.fieldAttributeList) === null || _form$fieldAttributeL3 === void 0 ? void 0 : (_form$fieldAttributeL4 = _form$fieldAttributeL3.find(function (v) {
        return v.type === 1001;
      })) === null || _form$fieldAttributeL4 === void 0 ? void 0 : _form$fieldAttributeL4.value));
    },
    getCallNumber: function getCallNumber(form) {
      var _form$fieldAttributeL5, _form$fieldAttributeL6;
      return form === null || form === void 0 ? void 0 : (_form$fieldAttributeL5 = form.fieldAttributeList) === null || _form$fieldAttributeL5 === void 0 ? void 0 : (_form$fieldAttributeL6 = _form$fieldAttributeL5.find(function (v) {
        return v.type === 2001;
      })) === null || _form$fieldAttributeL6 === void 0 ? void 0 : _form$fieldAttributeL6.value;
    },
    callbackSign: function callbackSign(sign) {
      this.item.tfvvalue = sign;
    },
    handleSign: function handleSign(item, index) {
      var _this5 = this;
      this.writeShow = true;
      this.$nextTick(function () {
        setTimeout(function () {
          var _this5$$refs, _this5$$refs$WriteExe;
          (_this5$$refs = _this5.$refs) === null || _this5$$refs === void 0 ? void 0 : (_this5$$refs$WriteExe = _this5$$refs.WriteExecute) === null || _this5$$refs$WriteExe === void 0 ? void 0 : _this5$$refs$WriteExe.clear();
        }, 200);
      });
    },
    calcValue: function calcValue(form) {
      var _form$fieldAttributeL7, _form$fieldAttributeL8;
      return calcFormula({
        formula: (form === null || form === void 0 ? void 0 : (_form$fieldAttributeL7 = form.fieldAttributeList) === null || _form$fieldAttributeL7 === void 0 ? void 0 : (_form$fieldAttributeL8 = _form$fieldAttributeL7.find(function (v) {
          return v.type === 1901;
        })) === null || _form$fieldAttributeL8 === void 0 ? void 0 : _form$fieldAttributeL8.value) || '',
        data: this.fieldList,
        format: function format(p, e) {
          p[e.id] = e.value;
          return p;
        }
      });
    },
    handleCall: function handleCall(phoneNumber) {
      this.$DingTalk.biz.telephone.showCallMenu({
        phoneNumber: phoneNumber,
        // 期望拨打的电话号码
        code: '+86',
        // 国家代号，中国是+86
        showDingCall: true,
        // 是否显示钉钉电话
        onSuccess: function onSuccess() {},
        onFail: function onFail() {}
      });
    },
    arrCopyValue: function arrCopyValue(item) {
      return {
        get: function get() {
          return item.value ? item.value.split(',') : [];
        },
        set: function set(v) {
          item.$emit('input', v.join(','));
        }
      };
    },
    spliteHyperLink: function spliteHyperLink() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      url = url || '';
      var index = url.indexOf(',') > 0 ? url.indexOf(',') : 0;
      return [url.slice(0, index), url.slice(index + 1)];
    }
  }
};